import React from "react";

const TrophyStatsDivider = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="2"
    height="56.068"
    {...props}
    viewBox="0 0 2 56.068"
    aria-label="trophy stats divider">
    <path
      fill="none"
      stroke="#999"
      strokeDasharray="0.1 8"
      strokeLinecap="round"
      strokeWidth="2px"
      d="M0 0h54.068"
      transform="translate(1 1) rotate(90)"
    />
  </svg>
);

export default TrophyStatsDivider;
